module.exports = __webpack_public_path__ + "static/media/aftershow5JJS.2039ffb0.jpg";